// import RecommendationsApi from '../api/profiles';
import FaqsApi from '../api/faqs';

export default {
  namespaced: true,
  state: {
    faqs: [],
  },
  getters: {
    allFaqs: state => state.faqs,
  },
  actions: {
    getFaqs(context, language = 'en') {
      return new Promise(async (resolve) => {
        const faqs = await FaqsApi.getFaqs(language);

        context.commit('SET_FAQS', faqs);
        resolve(faqs);
      });
    },
    createFaq(context, faq) {
      return new Promise(async (resolve) => {
        const createdFaq = await FaqsApi.createFaq(faq);

        resolve(createdFaq);
      });
    },
    updateFaq(context, faq) {
      return new Promise(async (resolve) => {
        const updatedFaq = await FaqsApi.updateFaq(faq);

        resolve(updatedFaq);
      });
    },
    deleteFaq(context, faq) {
      return new Promise(async (resolve) => {
        const deletedFaq = await FaqsApi.deleteFaq(faq);

        resolve(deletedFaq);
      });
    },
  },
  mutations: {
    SET_FAQS(state, faqs) {
      state.faqs = faqs;
    },
  },
};
